import { DadosSemEstoqueDisponivel } from "app/components/editar-item/produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivel";
import { EntitesProdutoAgregado } from "app/components/agregados/Agregados";
import { EntitesDadosEstoque } from "app/components/Estoque/Estoque";
import { DadosPedidoCliente } from "app/components/Estoque/sub-consultas/pedidos-cliente/PedidosCliente";
import { PesquisaSubConsultas } from "app/components/Estoque/sub-consultas/pedidos-cliente/PedidoClienteContainer";
import { DadosPedidosFornecedor } from "app/components/Estoque/sub-consultas/pedidos-fornecedor/PedidosFornecedor";
import { EntitesReservaProduto, PesquisaSubConsultasReserva } from "app/components/itens-orcamento/reserva-produto/Reservaproduto";
import { Filial, ListaTipo, MovimentacaoEstoque } from "app/components/movimentacao-estoque/MovimentacaoEstoque";
import { PesquisaProdutoPagina } from "app/components/pesquisa-produtos/PaginaPesquisaProdutoContainer";
import { DadosClasseProduto } from "app/components/pesquisa-produtos/pesquisa-classe/PesquisaClasse";
import { DadoPesquisaCorTintometrico, FiltroPesquisaCorTintometrico } from "app/components/pesquisa-produtos/pesquisa-cor-tintometrico/PesquisaCorTintometrico";
import { PreVenda } from "app/components/pesquisa-produtos/pesquisa-pre-vendas/PesquisaPreVendas";
import { FiltrosObterProdutosForaEstoque } from "app/components/pesquisa-produtos/produtos-fora-estoque/ProdutosForaEstoque";
import { EntitesSimilares } from "app/components/similares/Similares";
import { DadosSugerirProdutoAgregado } from "app/components/sugerir-produto-agregado/SugerirProdutoAgregado";
import { DadosUltimasCompras, FiltroUltimasComprasProdutos } from "app/components/ultimas-compras-produtos/UltimasComprasProdutos";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { ILotes } from "app/types/ILotes";
import { ILotesReservados } from "app/types/ILotesReservados";
import { FiltroEstoque } from "app/types/produto/FiltroEstoque";
import { FiltroListarOfertas } from "app/types/produto/FiltroListarOfertas";
import { FiltroLotes } from "app/types/produto/FiltroLotes";
import { FiltroMovimentacaoEstoque } from "app/types/produto/FiltroMovimentacaoEstoque";
import { FiltroPesquisaConsulta } from "app/types/produto/FiltroPesquisaConsulta";
import { FiltroPesquisaProdutos } from "app/types/produto/FiltroPesquisaProdutos";
import { FiltroTributacao } from "app/types/produto/FiltroTributacao";
import { IProduto } from "app/types/produto/IProduto";
import { DadosTabelaProdutosForaEstoque } from "app/types/produto/ProdutoForaEstoque";
import { DadosPesquisaOfertas, RespostaOfertas } from "app/types/produto/RespostaOfertas";
import { DadosTributacao } from "app/types/produto/RespostaTributacao";
import { Disponibilidade } from "../../components/pesquisa-produtos/mais-filtros/MaisFiltros";
import { DomainDataType } from "../types/DomainDataType";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";
import { Encomendas, PesquisaSubConsultasEncomenda } from "app/components/Estoque/sub-consultas/encomenda/EncomendaProduto";
import { DadosAnaliseGerencialProdutoItem, FiltroAnaliseGerencialProdutoItem } from "app/components/AnaliseGerencialProdutoItem/AnaliseGerencialProdutoItem";
import { DadosOrdemProducaoEmAberto } from "app/components/ordem-producao/consulta-ordem-de-producao-aberto/ConsultaOrdemDeProducaoAberto";
import { ObterNotasFiscaisPendentesApi } from "app/components/Estoque/sub-consultas/notas-fiscais-pendentes/NotasFiscaisPendentesContainer";
import { NotasFiscaisPendentes } from "app/components/Estoque/sub-consultas/notas-fiscais-pendentes/NotasFiscaisPendentes";


export class ProdutoApi extends BaseApi {
  async pesquisar(filtro: FiltroPesquisaProdutos | PesquisaProdutoPagina): Promise<IProduto[]> {
    const { data } = await this.api.post(`/Produto/Pesquisar`, filtro);
    return data?.Entities || [];
  }

  async pesquisarProduto(
    filtro: FiltroPesquisaProdutos | PesquisaProdutoPagina | any
  ): Promise<PagedMessageResponse<IProduto>> {
    const resposta = await this.api.post(`/Produto/Pesquisar`, filtro);
    return resposta?.data;
  }

  async pesquisarProdutoUnico(
    codigoOuReferencia: string,
    identificadorOrcamento: string,
    somarQuantidadeProdutoRepetido?: boolean // 491040
  ): Promise<DomainDataType<PagedMessageResponse<IProduto>>> {
    const resposta = await this.api.post(`/Produto/PesquisarUnicoProduto`, {
      codigoOuReferencia,
      NumeroPagina: 1,
      TamanhoPagina: 20,
      identificadorOrcamento,
      somarQuantidadeProdutoRepetido, // 491040
    });

    return resposta.data;
  }

  async obterDadosLotesReservadosProdutoConsulta(filtros: FiltroLotes): Promise<ILotesReservados> {
    const resposta = await this.api.post(`/Produto/ObterDadosLotesReservadosProdutoConsulta`, {
      filtros
    })

    return resposta.data
  }

  async obterDadosLotesProdutoConsulta(filtros: FiltroLotes): Promise<ILotes> {
    const resposta = await this.api.post(`/Produto/ObterDadosLotesProdutoConsulta`, {
      filtros
    })

    return resposta.data
  }

  async ultimasComprasProduto(filtros: FiltroUltimasComprasProdutos): Promise<DadosUltimasCompras[]> {
    const resposta = await this.api.post(`/Produto/UltimasComprasProduto`, {
      filtros
    })

    return resposta.data
  }

  async obterDadosEstoque(pesquisa: FiltroEstoque): Promise<PagedMessageResponse<EntitesDadosEstoque>> {
    const resposta = await this.api.post(`/Produto/ObterDadosEstoque`, {
      pesquisa
    })

    return resposta.data
  }

  async obterDadosAnaliseGerencial(filtro: FiltroAnaliseGerencialProdutoItem): Promise<DadosAnaliseGerencialProdutoItem> { // 433081
    const resposta = await this.api.post(`/Produto/obterDadosAnaliseGerencial`, { filtro })
    return resposta.data
  }

  async dadosOfertas(identificadorOrcamento: string, filtros: FiltroListarOfertas): Promise<RespostaOfertas> {
    const resposta = await this.api.post(`/Produto/DadosOfertas`, {
      identificadorOrcamento, filtros
    })

    return resposta.data
  }

  async listarProdutosOrdemProducao(identificadorOrcamento: string, filtros: DadosOrdemProducaoEmAbertoFiltros): Promise<Partial<PagedMessageResponse<DadosOrdemProducaoEmAberto>>> {
    const resposta = await this.api.post(`/Produto/ListarProdutosOrdemProducao`, {
      identificadorOrcamento, filtros
    })

    return resposta.data
  }

  async listarOfertasProduto(identificadorOrcamento: string, filtros: FiltroListarOfertas): Promise<DadosPesquisaOfertas> {
    const resposta = await this.api.post(`/Produto/ListarOfertasProduto`, {
      identificadorOrcamento, filtros
    })
    return resposta.data
  }

  async dadosMovimentacaoEstoque(filtro: FiltroMovimentacaoEstoque): Promise<MovimentacaoEstoque[]> {
    const resposta = await this.api.post(`/Produto/MovimentacaoEstoque`, {
      filtro
    })

    return resposta.data
  }

  async listarFiliais(): Promise<Filial[]> {
    const resposta = await this.api.get(`/Produto/ListarFiliais`)

    return resposta?.data
  }

  async dadosTposPorAtributo(atributo: string): Promise<ListaTipo[]> {
    const resposta = await this.api.post(`/Produto/ListarTposPorAtributo`, {
      atributo
    })

    return resposta.data
  }

  async dadosAgregados(codigoProduto: string): Promise<PagedMessageResponse<EntitesProdutoAgregado>> {
    const resposta = await this.api.post(`/Produto/DadosAgregados`, {
      codigoProduto
    })
    return resposta.data
  }

  async consultarAgregados(pesquisaProdutoContract: FiltroPesquisaConsulta): Promise<PagedMessageResponse<EntitesProdutoAgregado>> {
    const resposta = await this.api.post(`/Produto/ConsultarAgregados`, {
      pesquisaProdutoContract
    })
    return resposta.data
  }

  async dadosSimilares(codigoProduto: string): Promise<PagedMessageResponse<EntitesSimilares>> {
    const resposta = await this.api.post(`/Produto/DadosSimilares`, {
      codigoProduto
    })
    return resposta.data
  }

  async consultarSimilares(pesquisaProdutoContract: FiltroPesquisaConsulta): Promise<PagedMessageResponse<EntitesSimilares>> {
    const resposta = await this.api.post(`/Produto/ConsultarSimilares`, {
      pesquisaProdutoContract
    })
    return resposta.data
  }

  async listarLotesReservados(filtros: FiltroLotes): Promise<ILotesReservados> {
    const resposta = await this.api.post(`/Produto/ListarLotesReservados`, {
      filtros
    })
    return resposta.data
  }

  async dadosTributacao(filtros: FiltroTributacao): Promise<DadosTributacao> {
    const resposta = await this.api.post(`/Produto/DadosTributacaoProduto`, {
      filtros
    })
    return resposta.data
  }

  async pedidoCliente(pesquisa: PesquisaSubConsultas): Promise<PagedMessageResponse<DadosPedidoCliente>> {
    const resposta = await this.api.post(`/Produto/PedidoCliente`, {
      pesquisa
    })
    return resposta.data
  }

  async pedidoFornecedor(pesquisa: PesquisaSubConsultas): Promise<PagedMessageResponse<DadosPedidosFornecedor>> {
    const resposta = await this.api.post(`/Produto/PedidoFornecedor`, {
      pesquisa
    })
    return resposta.data
  }

  async dadosReservaProduto(pesquisa: PesquisaSubConsultasReserva): Promise<PagedMessageResponse<EntitesReservaProduto>> {
    const resposta = await this.api.post(`/Produto/ObterDadosReserva`, {
      pesquisa
    })
    return resposta.data
  }

  async dadosEncomendaProduto(pesquisa: PesquisaSubConsultasEncomenda): Promise<Encomendas[]> {
    const resposta = await this.api.post(`/Produto/ObterDadosEncomenda`, {
      filtro: pesquisa
    })
    return resposta.data
  }

  async obterNotasFiscaisPendentes(pesquisa: ObterNotasFiscaisPendentesApi): Promise<NotasFiscaisPendentes[]> {
    const resposta = await this.api.post(`/Produto/ObterNotasFiscaisPendentes`, {
      filtro: pesquisa
    })
    return resposta.data
  }

  async dadosProdutoAgregado(filtros: any): Promise<DadosSugerirProdutoAgregado[]> {
    const resposta = await this.api.post(`/Produto/ListarProdutoAgregado`, {
      filtros
    })
    return resposta.data
  }

  async listarClassesProdutos(): Promise<DadosClasseProduto[]> {
    const resposta = await this.api.get(`/Produto/ListarClassesProdutos`);

    return resposta.data;
  }

  async obterMarkupPesquisaProdutos(
    produtos: string,
    identificadorOrcamento: string
  ): Promise<IItemOrcamento[]> {

    const resposta = await this.api.post(
      `/Produto/ObterMarkupPesquisaProdutos`,
      {
        produtos,
        identificadorOrcamento,
      }
    );

    return resposta.data;
  }

  async pesquisarPreVenda(
    pesquisar: FiltroPesquiaPreVenda
  ): Promise<PagedMessageResponse<PreVenda>> {
    const resposta = await this.api.post(`/Produto/PesquisarPreVenda`, {
      pesquisar,
    });

    return resposta.data;
  }

  async pesquisaCor(filtros: FiltroPesquisaCor): Promise<DadoPesquisaCor> {
    const resposta = await this.api.post(`/Produto/PesquisarCor`, { filtros });

    return resposta.data;
  }

  async mascaraClasseProduto(): Promise<string> {
    const resposta = await this.api.get(`/Produto/MascaraClasseProduto`);

    return resposta.data;
  }

  async listarSistemaTintometrico(): Promise<ListaSistemaTintometrico[]> {
    const resposta = await this.api.get(`/Produto/ListarSistemaTintometrico`);

    return resposta.data;
  }

  async obterPrecoProdutoTintaPesquisa(identificadorOrcamento: string, produto: IItemOrcamento): Promise<number> {
    const resposta = await this.api.post(`/Produto/ObterPrecoProdutoTintaPesquisa`, {
      identificadorOrcamento,
      produto
    });

    return resposta.data;
  }

  async produtosForaEstoque(): Promise<PagedMessageResponse<DadosTabelaProdutosForaEstoque>> {
    const resposta = await this.api.post(`/Produto/ProdutosForaEstoque`);

    return resposta.data;
  }

  async obterProdutosForaEstoque(filtros: FiltrosObterProdutosForaEstoque): Promise<PagedMessageResponse<DadosTabelaProdutosForaEstoque>> {
    const resposta = await this.api.post(`/Produto/ObterProdutosForaEstoque`, {
      filtros
    });

    return resposta.data;
  }

  async trabalhaComCodigoOuReferencia(): Promise<string> {
    const resposta = await this.api.post(`/Produto/LabelProdutoComponent`);

    return resposta.data;
  }


  async historicoFiltro(
    idFiltro: number,
    vendedorId: string,
    codigoCliente: number,
    checkFiltrarCliente: boolean
  ): Promise<HistoricoFiltro[]> {
    const resposta = await this.api.post(`/Produto/_HistoricoFiltros`, {
      idFiltro,
      vendedorId,
      codigoCliente,
      checkFiltrarCliente,
    });

    return resposta.data;
  }

  async ObterDisponibilidades(): Promise<Disponibilidade[]> {
    const response = await this.api.get(`/Produto/ObterDisponibilidades`);
    return response?.data;
  }

  async DadosClassesProdutos(): Promise<DomainDataType<DadosClasseProduto[]>> {
    const resposta = await this.api.get(`/Produto/DadosClassesProdutos`, {
      params: {}
    })

    return resposta.data
  }


  async vendaProdutoEstoqueIndisponivel(identificador: number, identificadorOrcamento: string): Promise<DadosSemEstoqueDisponivel> {
    const resposta = await this.api.post(`/Produto/VendaProdutoEstoqueIndisponivel`, {
      identificador,
      identificadorOrcamento
    })

    return resposta.data
  }

  async PesquisarCores(filtro: FiltroPesquisaCorTintometrico): Promise<PagedMessageResponse<DadoPesquisaCorTintometrico>> {
    const response = await this.api.post(`/Produto/PesquisarCores`, filtro);
    return response?.data;
  }

  async ValidarCorInformada(codigoCor: string, codigoProduto: string): Promise<DomainDataType<Boolean>> {
    return (await this.api.post(`/Produto/ValidarCorInformada`, {
      codCor: codigoCor,
      codigoProduto: codigoProduto
    })).data;
  }

  async obterDadosRma(codigoProduto: string, codigoFilial: string): Promise<DadosRma[]> {
    const resposta = await this.api.get(`/Produto/ObterDadosRma`, {
      params: { codigoProduto, codigoFilial }
    });
    return resposta.data;
  }
}


export type PesquisarProdutoFiltro = {
  Codigo?: string;
  Referencia?: string;
  TamanhoPagina?: number;
  NumeroPagina?: number;
  identificadorOrcamento: string;
};

export type HistoricoFiltro = {
  Data: string;
  Filtro: string;
  FiltroFormatado: string;
  Id: number;
  Selecionado: boolean;
  SelecionadoClass: string;
  TipoPesquisa: number;
  Usuario: number;
  OidCliente: any;
  CodVendedor: string;
};

export type FiltroPesquiaPreVenda = {
  Localizar: string;
  NumeroPagina: number;
  TamanhoPagina: number;
};

export type FiltroPesquisaCor = {
  CodigoCorFabricante?: string;
  CodigoProduto: string;
  DescricaoCor?: string;
  NumeroPagina: number;
  TamanhoPagina: number;
};

export type DadoPesquisaCor = {
  CodigoCorFabricante?: string;
  CodigoProduto: string;
  CoresProduto: PesquisaCor;
  DescricaoCor?: string;
  Legenda: string;
  Entities?: any;
  NumeroPagina: number;
  TamanhoPagina: number;
  Transforming: false;
  UserMessage?: string;
};

export type DadosOrdemProducaoEmAbertoFiltros = {
  TamanhoPagina: number
  NumeroPagina: number
  CodigoProduto: string
}

export type PesquisaCor = {
  Entities: Cor[];
  ActualPage: number;
  IsLastPage: boolean;
  PageCount: number;
  PageSize: number;
  RowsCount: number;
  StartIndex: number;
};

export type Cor = {
  Codigo: string;
  CodigoExterno: string;
  CodigoExterno2: string;
  ExigeFundoLoc: boolean;
  Inativo: boolean;
  Nome: string;
  Transforming: boolean;
  UserMessage: string;
  selecionado: boolean;
};

export type ListaSistemaTintometrico = {
  Codigo: number,
  Descricao: string
  UserMessage?: string,
  Transforming?: boolean
}

export type DadosRma = {
    Cliente: string;
    OrdemServico: string;
    CodigoProduto: string;
    Quantidade: number;
    DataEntrada: string;
    HistoricoRMA: string;
};
